<template>
  <div class="jisaoCopyRight">
    <div clss="banquan">
      云祭扫重视知识产权、肖像权及其他权利的保护，若本客户端中的内容侵犯您的版权、肖像权或其他权利的，请告知我们，若属于有效投诉，我们将及时删除侵权内容。
    </div>
  </div>
</template>

<script>
export default {
  name: 'copyright',
  data() {
    return {}
  },
}
</script>

<style>
.jisaoCopyRight {
  color: #bbb;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  margin: 20px auto;
  padding: 10px 20px;
  border-top: 1px solid #ccc;
}
</style>
